module.exports = __webpack_public_path__ + "media/flavours/glitch/images/wave-drawer-ee1bfcbe5811ea31771b7187c7507ee6.png";